<div class="form-grid">
  <label>
    <span>Image</span>
    <select [ngModel]="block.imageId" (ngModelChange)="updateImageId($event)">
      <option [ngValue]="null">Select image</option>
      @for (image of availableImages; track image.id) {
        <option [ngValue]="image.id">{{ image.originalFileName }}</option>
      }
    </select>
  </label>
  <label>
    <span>Alt override</span>
    <input
      [ngModel]="block.imageAltOverride"
      placeholder="Override default alt text"
      (ngModelChange)="updateImageAltOverride($event)" />
  </label>
</div>

<label>
  <span>Caption override</span>
  <input
    [ngModel]="block.imageCaptionOverride"
    placeholder="Override default caption"
    (ngModelChange)="updateImageCaptionOverride($event)" />
</label>

@if (selectedImage) {
  <div class="inline-preview">
    <img class="media-preview" [src]="selectedImage.contentUrl" [alt]="selectedImage.defaultAlt || selectedImage.originalFileName" />
    <p class="field-note">Defaults: {{ selectedImage.defaultAlt || 'No alt' }} / {{ selectedImage.defaultCaption || 'No caption' }}</p>
  </div>
}
